import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';
import Select from './components/Select.vue';

export const OrganizacniJednotky = {
	name: NAME,
	router,
	apiProvider,
	components: {
		Select,
	},
};
